/**
 * abilityVfxBoomerangBlade — Sivir Q Boomerang Blade jeweled crossblade (SP-17).
 */
export function buildBoomerangBlade(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.95 * (spec.scale || 1.15);
  const amber = mat(THREE, spec.color || 0xf59e0b, 0.95);
  const jewel = mat(THREE, 0xfef08a, 0.98);
  const steel = mat(THREE, 0xfde68a, 0.9);
  addCrossArms(THREE, group, s, amber, steel);
  addHub(THREE, group, s, jewel, amber);
  addTips(THREE, group, s, jewel);
  addTrail(THREE, group, s, amber);
  group.userData = { shape: 'boomerang_blade' };
  return group;
}

function addCrossArms(THREE, group, s, amber, steel) {
  const long = new THREE.Mesh(new THREE.BoxGeometry(1.6 * s, 0.08 * s, 0.28 * s), amber);
  group.add(long);
  const cross = new THREE.Mesh(new THREE.BoxGeometry(0.28 * s, 0.08 * s, 1.35 * s), steel);
  group.add(cross);
}

function addHub(THREE, group, s, jewel, amber) {
  const gem = new THREE.Mesh(new THREE.SphereGeometry(0.16 * s, 10, 10), jewel);
  gem.position.y = 0.06 * s;
  group.add(gem);
  const rim = new THREE.Mesh(new THREE.SphereGeometry(0.22 * s, 10, 10), amber);
  rim.position.y = 0.04 * s;
  group.add(rim);
}

function addTips(THREE, group, s, jewel) {
  const offsets = [
    [0.75 * s, 0],
    [-0.75 * s, 0],
    [0, 0.65 * s],
    [0, -0.65 * s]
  ];
  for (let i = 0; i < offsets.length; i += 1) {
    const tip = new THREE.Mesh(new THREE.ConeGeometry(0.08 * s, 0.22 * s, 5), jewel);
    tip.position.set(offsets[i][0], 0.02 * s, offsets[i][1]);
    group.add(tip);
  }
}

function addTrail(THREE, group, s, amber) {
  const trail = new THREE.Mesh(
    new THREE.SphereGeometry(0.1 * s, 8, 8),
    amber
  );
  trail.position.z = -0.55 * s;
  group.add(trail);
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
